module.exports = __webpack_public_path__ + "img/xjbd.11c82936.jpg";